import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import './PremiumTrialModal.css';
import PageButton from '../../elements/PageButton/PageButton';
import {CONTACTS_CONTENT} from '../../../configs/contacts';

const PAGE_ID = 'PremiumTrialModal';

// Та же контактная почта, что и в легальных документах (страница «Контакты»)
const CONTACT_EMAIL = CONTACTS_CONTENT.blocks.find((block) => block.type === 'emailLink')?.email
  || 'strategikon.game@yandex.ru';

/**
 * Модалка раннего доступа к премиуму (поверх модалки ежедневных наград):
 * покупка пока недоступна, но пробный период можно запросить письмом —
 * ссылка открывает почтовый клиент с предзаполненными темой и текстом.
 */
function PremiumTrialModal({onClose}) {
  const playerName = useSelector((state) => state.private.auth.name);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const showTimer = setTimeout(() => setVisible(true), 50);
    return () => clearTimeout(showTimer);
  }, []);

  const handleClose = () => {
    setVisible(false);
    setTimeout(() => onClose?.(), 300);
  };

  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget) {
      handleClose();
    }
  };

  const subject = 'Пробный Премиум';
  const body = `Здравствуйте!\n\nПрошу начислить бесплатный пробный период Премиума на аккаунт ${playerName}.`;
  const mailtoHref = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

  return (
    <div
      className={`premium-trial-overlay ${visible ? 'premium-trial-overlay_visible' : ''}`}
      onClick={handleOverlayClick}
      role="dialog"
      aria-modal="true"
    >
      <div className="premium-trial-modal">
        <p className="premium-trial-text">
          Покупка Премиума скоро будет доступна.
          <br/>
          Но в рамках раннего доступа Вы можете получить бесплатный пробный
          период, обратившись к администрации сайта:
        </p>

        <a className="premium-trial-mail-link" href={mailtoHref}>
          <img className="premium-trial-mail-icon" src="/img/icons/premium.png" alt="Премиум"/>
          {CONTACT_EMAIL}
        </a>

        <div className="main-menu-buttons premium-trial-buttons">
          <PageButton
            className="main-menu-button_secondary"
            onClick={handleClose}
            pageId={PAGE_ID}
            buttonId="hide"
          >
            Скрыть
          </PageButton>
        </div>
      </div>
    </div>
  );
}

export default PremiumTrialModal;
